export const MARKETPLACE_GUIDE_SESSION_KEY = 'disasterms_saas_marketplace_guide_dismissed';

const sessionStorageForBrowser = () => {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  } catch (_) {
    return null;
  }
};

export const marketplaceGuideWasDismissed = () => {
  try {
    return sessionStorageForBrowser()?.getItem(MARKETPLACE_GUIDE_SESSION_KEY) === '1';
  } catch (_) {
    return false;
  }
};

export const dismissMarketplaceGuide = () => {
  try {
    sessionStorageForBrowser()?.setItem(MARKETPLACE_GUIDE_SESSION_KEY, '1');
  } catch (_) {
    // The guide still closes for the current render when storage is blocked.
  }
};

export const resetMarketplaceGuideForNextLogin = () => {
  try {
    sessionStorageForBrowser()?.removeItem(MARKETPLACE_GUIDE_SESSION_KEY);
  } catch (_) {
    // Nothing else is required when storage is blocked.
  }
};
